import React, { useState, JSX } from 'react';
import { GenericModal } from '../GenericModal';
import LoginBox from './LoginBox';
import { FAIcon } from '../fa-icon';

type Props = {
  authCapabilities: object;
  authUrls: string[];
  css_class: string;
  hideLogin: boolean;
  icon: string;
  idProvidersUrl: string;
  login_text: string;
  name: string;
  onLoginLoad: () => void;
  socialIcon: string;
};

const LoginLink: React.FC<Props> = ({
  authCapabilities,
  authUrls,
  css_class,
  hideLogin,
  icon,
  idProvidersUrl,
  login_text,
  name,
  onLoginLoad,
  socialIcon,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const open = (e: React.SyntheticEvent): void => {
    setShowModal(true);
    e.preventDefault();
  };

  const close = (): void => {
    setShowModal(false);
  };

  const linkContent = (): JSX.Element => {
    const css: string = (css_class || '') + 'btn btn-primary btn-primary-branded capitalize';
    if (icon) {
      return (
        <a onClick={open} className={css} href="#">
          {/* Remove when FAIcon is TypeScript-ified */}
          {/* @ts-ignore  */}
          <FAIcon icon={icon} /> {name}
        </a>
      );
    } else {
      return (
        <a onClick={open} className={css} href="#">
          {name}
        </a>
      );
    }
  };

  return (
    <div className="login-link">
      {!hideLogin && linkContent()}
      {showModal && (
        /* @ts-ignore */
        <GenericModal onClose={close} modalClass="login-reg-modal" canClose={true}>
          <LoginBox
            loginText={login_text}
            idProvidersUrl={idProvidersUrl}
            authCaps={authCapabilities}
            authUrls={authUrls}
            socialIcon={socialIcon}
            onLoginLoad={onLoginLoad}
          />
        </GenericModal>
      )}
    </div>
  );
};

export default LoginLink;
